export default class ApiModel {
  constructor(attributes) {
    for (let attr in attributes)
      this[attr] = attributes[attr]
    this.loadedAt = Date.now()
  }
}
